import { render, staticRenderFns } from "./MainSideBar.vue?vue&type=template&id=380ad7b8&scoped=true"
import script from "./MainSideBar.vue?vue&type=script&lang=js"
export * from "./MainSideBar.vue?vue&type=script&lang=js"
import style0 from "./MainSideBar.vue?vue&type=style&index=0&id=380ad7b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "380ad7b8",
  null
  
)

export default component.exports